import React, { useState } from 'react';
import loadable from '@loadable/component';
import { Grid, Container, Typography, useMediaQuery } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const GeneralTestimonial = loadable(() => import('./GeneralTestimonial'));
const TestimonialCarousel = loadable(() => import('./TestimonialCarousel'));

const useStyles = makeStyles((theme) => ({
  testimonialTitle: {
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
      marginBottom: 0,
    },
  },
}));

export const Testimonials = ({ header, testimonials, formRef, background }) => {
  const classes = useStyles();

  const [carouselTestimonialArray] = useState(testimonials);
  const med = useMediaQuery('(max-width: 960px)');
  const video = testimonials.length ? testimonials[0]?.videoVariant : null;
  return (
    <Container>
      <Grid
        container
        direction='row'
        justifyContent={video ? 'center' : 'flex-start'}
        alignItems='center'
      >
        <Grid item xs={12}>
          <Typography
            variant='h2'
            style={{
              color: background ? 'white' : '#3FA529',
              textAlign: video && 'center',
            }}
            className={classes.testimonialTitle}
          >
            {header ?? null}
          </Typography>
        </Grid>
      </Grid>

      {med ? (
        <Grid
          container
          direction='row'
          justifyContent='center'
          alignItems='center'
        >
          <TestimonialCarousel
            carouselTestimonialArray={carouselTestimonialArray}
            ref={formRef}
          />
        </Grid>
      ) : (
        <>
          <GeneralTestimonial testimonials={testimonials} video={video} />
        </>
      )}
    </Container>
  );
};
